import { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext(null);
const read = (k, d) => localStorage.getItem(k) || d;

export function ThemeProvider({ children }) {
  const [scheme, setScheme] = useState(read("tf.scheme", "system"));
  const [accent, setAccent] = useState(read("tf.accent", "blue"));

  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => {
      const dark = scheme === "dark" || (scheme === "system" && mq.matches);
      document.documentElement.classList.toggle("dark", dark);
    };
    apply();
    localStorage.setItem("tf.scheme", scheme);
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, [scheme]);

  useEffect(() => {
    document.documentElement.dataset.accent = accent;
    localStorage.setItem("tf.accent", accent);
  }, [accent]);

  return <ThemeCtx.Provider value={{ scheme, setScheme, accent, setAccent }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);

// Fixed hex values used where CSS vars can't reach (charts, PDF).
export const STATE_HEX = { fight: "#E89B8C", flight: "#E6C288", freeze: "#7FB5C4", fawn: "#A6A8E0" };
export const sudsVar = (v) => (v >= 7 ? "var(--hot)" : v >= 4 ? "var(--mid)" : "var(--cold)");
